<script>
import Modal from "@/components/_Shared/Modal";
import { mapActions } from "vuex";
export default {
  components: {
    Modal
  },

  data() {
    return {
      preloader: false,
      sent: false
    };
  },

  methods: {
    ...mapActions("user", ["sendEmailVerification"]),
    async send() {
      this.preloader = true;

      try {
        if (this.sent) throw "E-mail já foi reenviado!";
        await this.sendEmailVerification();
        this.sent = true;
      } catch (e) {}

      this.preloader = false;
    }
  }
};
</script>

<template>
  <div>
    <modal
      title="VERIFIQUE SEU E-MAIL"
      subtitle="O seu pedido será criado assim que você fizer a verificação do seu e-mail."
      size="md"
      @close="$emit('close')"
    >
      <template slot="body">
        <p>Caso você não tenha recebido o e-mail, clique no botão abaixo para reenviar o link de confirmação.</p>
      </template>
      <template slot="footer">
        <div
          class="btn"
          :class="{'btn--loading': preloader, 'bg-purple': !sent, 'bg-green': sent}"
          @click="send"
        >
          <span v-if="sent">E-mail enviado!</span>
          <span v-else>Reenviar e-mail</span>
        </div>
      </template>
    </modal>
  </div>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Steps/VerifyEmail.vue